<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-flex>
          <router-view></router-view>
        </v-flex>
      </v-flex>
    </v-layout>
    <ShowErrors class="px-2 mr-4" />
    <v-layout
      class="pb-4 pt-4"
      justify-center
      align-self-center
      row
			v-if="getStepHideNextPrev()"
    >
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-btn
          @click="setPreviousStep()"
          class="accent_light"
        >
          <v-icon class="reverse">arrow_right_alt</v-icon>
          Previous
        </v-btn>
        <v-btn
          @click="setNextStep()"
          :disabled="testCompleteGroup([0, 1, 2]) === false"
          class="accent"
        >
          Continue
          <v-icon>arrow_right_alt</v-icon>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import store from "../../store";
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import ShowErrors from "@/components/pages/ShowErrors.vue";

export default {
  name: "FormAccount",
  props: [],
  store: store,
  mixins: [BookingFormMixin, Shared],
  components: { ShowErrors },
  data() {
    return {
      formValid: false
    };
  },
  mounted() {
   const step = this.getStepNumberByPath("/booking/account");

    this.loginTest();

    if (store.state.active !== step) {
      store.commit("setActiveStep", step);
    }
    if (this.user.id !== null) {
      this.completeSection("Account");
    }
    else
    {
      this.unCompleteSection("Account");
    }
  }
};
</script>
